<template lang="pug">
    re-modal(@close="no" v-bind="parentOptions")
        include ./confirm-content-modal.pug
</template>

<script>
//re-modal-title
//.re-modal-subtitle
// .re-modal-buttons.confirmer-buttons
//
import ConfirmMixin from '../mixins/confirm'
import ReModal from 'utils/vue/components/modals/re-modal'
import ReButton from 'utils/vue/components/basic/buttons/re-button'

export default {
    name: 'cart-rules-confirm-modal',

    components: {
        ReModal,
        ReButton,
    },

    mixins: [
        ConfirmMixin
    ],

    data: () => ({
        defaultParentOptions: {
            skipCustomMount: true
        }
    })
}
</script>
